import { useTranslation } from "react-i18next";
import { Button } from '@mui/material';
import { GridColDef } from "@mui/x-data-grid";
import { useFormatNumber } from "../../../../../hooks/useFormatNumber";
import { useDates } from "../../../../../hooks/useDates";
import { useParamsFilter } from "../../../../../hooks/useParamsFilter";
import { ReceiptDetail } from "../../../../../interfaces/Sales/Receipts/receipts";

export const useReceiptDetailsColumns = () => {
    const { TimeConverter } = useDates();
    const { setFormatNumberFromTable } = useFormatNumber();
    const { ConvertParamsToBase64 } = useParamsFilter();
    const { t } = useTranslation("global");

    const columnsReceiptDetails: GridColDef<ReceiptDetail>[] = [
        {
            field: 'sales_invoice_name', headerName: t("salesinvoices.fields.sales_invoice_name"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                return <Button onClick={() => {
                    let stringConverted = ConvertParamsToBase64(`sales_invoice_id=${params.row.sales_invoice_id}&customer_id=${params.row.customer_id}`);
                    window.open(`/salesinvoices/view?${stringConverted}`, '_blank');
                }}>
                    {params.row.sales_invoice_name}
                </Button>
            }
        },
        {
            field: 'project_name', headerName: t("projects.fields.project_name"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                return <Button disabled={(params.row.project_name) ? false : true} onClick={() => {
                    let stringConverted = ConvertParamsToBase64(`project_id=${params.row.project_id}`);
                    window.open(`/projects/view?${stringConverted}`, '_blank');
                }}>
                    {params.row.project_name}
                </Button>
            }
        },
        { field: 'customer_business_name', headerName: t("receiptsdetails.fields.customer_bussines_name"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'receipt_name', headerName: t("receipts.fields.receipt_name"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'uuid', headerName: t("receipts.fields.uuid"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'status_name', headerName: t("receiptsdetails.fields.status_name"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'related_currency_code', headerName: t("currencies.title-view"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'amount_outstanding', headerName: t("receiptsdetails.fields.amount_outstanding"), headerClassName: 'header-grid-table', flex: 1, type: 'number', align: 'left', headerAlign: 'left',
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        {
            field: 'total_company_currency_amount', headerName: t("companies.configuration.fields.total_company_currency_amount"), headerClassName: 'header-grid-table', flex: 1,
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        {
            field: 'payment_deadline', headerName: t("receiptsdetails.fields.payment_deadline"), headerClassName: 'header-grid-table', type: "date", flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
        { field: 'user_mail_send', headerName: t("receipts.fields.user_mail_send"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'date_mail_send', headerName: t("receipts.fields.date_mail_send"), headerClassName: 'header-grid-table', flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value)?.toLocaleString();
            },
        },
        {
            field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
        { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
    ];

    return {
        columnsReceiptDetails,
    };
};